import { Base } from "regexp-tree/ast";
import BaseDialog from "../modelDialogs/BaseDialog";
import { ConsistencyErrorLogEntry } from "../models/ConsistencyErrorLogEntry";
import ObjectReference from "./ObjectReference";
import BaseModel from "../models/BaseModel";
import { isDevelopmentEnvironment } from "../estada-config";
import { itx } from "../translationItx/itx";
import { useEffect, useRef } from "react";
import { allignColumnTreeview } from "../modelViews/GraficElementUtils";
import { useRedraw } from "../models/useRerender";
import openShowErrorsToUsersOutsideOfDevelopment from "./dialogs/ShowErrorsToUsersOutsideOfDevelopment";

export default function ConsitencyErrorsDialog(params: { consistencyCheckLog: Array<ConsistencyErrorLogEntry> }) {
  const { consistencyCheckLog } = params;

  const redraw = useRedraw();

  const rootRef = useRef<HTMLDivElement>(null);

  const errElements: any = [];

  useEffect(() => {
    //
    // allign columns after render
    //
    setTimeout(() => {
      if (rootRef.current) {
        const ulElm = document.getElementById("navigationTreeUl");
        allignColumnTreeview("objReference", rootRef.current, 300); // no itx
      }
    }, 100);
  }, []);

  consistencyCheckLog.forEach((err, index) => {
    const obj = state.objectRegistry.getObject(err.id) as BaseModel;
    errElements.push(
      <div key={`i_${index}`} style={{ display: "flex", flexDirection: "row", gap: "10px", whiteSpace: "nowrap" }}>
        <ObjectReference
          className=""
          style={{
            width: "initial",
            minWidth: "100px",
          }}
          obj={obj}
          showName={true}
          useSimpleFulltag={true}
          useAllwaysMaxSpace={false}
        />

        <div>{obj ? itx("components." + obj.className, obj.className) : ""}: </div>
        <div>{err?.message || ""}</div>
      </div>,
    );
  });

  return (
    <BaseDialog
      title={itx("components.ConsistencyErrorsDialog.title", "Fehler im Projekt")}
      moreButtons={
        <button
          className="button"
          onClick={() => {
            state.consistencyCheckLog = [];
            redraw();
          }}
        >
          {itx("components.ConsistencyErrorsDialog.clearList", "Liste leeren")}
        </button>
      }
    >
      <div ref={rootRef}>{errElements}</div>
    </BaseDialog>
  );
}

export function showConsitencyErrorsDialog(consistencyCheckLog: Array<ConsistencyErrorLogEntry>) {
  const show = consistencyCheckLog; //.filter((entry) => entry.userError);
  // check if we are in / app
  if (!window.location.pathname.includes("/app")) {
    return;
  }
  if (!isDevelopmentEnvironment()) {
    // in production we only show user specific errors
    // openShowErrorsToUsersOutsideOfDevelopment();
    return;
  }
  if (show.length > 0) {
    state.dialogManager.openDialog(<ConsitencyErrorsDialog consistencyCheckLog={consistencyCheckLog} />, false, false);
  }
}
